import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import QuoteSection from "../components/QuoteSection";
import LeShiatsu from "../components/LeShiatsu";
import PourQui from "../components/PourQui";
import Seance from "../components/Seance";
import Praticienne from "../components/Praticienne";
import Tarifs from "../components/Tarifs";
import CartesCadeaux from "../components/CartesCadeaux";
import QVCT from "../components/QVCT";
import Contact from "../components/Contact";
import BlogPreview from "../components/BlogPreview";
import Footer from "../components/Footer";
import useSEO from "../hooks/useSEO";
import { siteData } from "../mock";

const Home = () => {
  useSEO({
    title:
      "Catherine' Shiatsu — Praticienne en Shiatsu à La Ciotat | Détente & Bien-être",
    description:
      "Séances de Shiatsu à La Ciotat par Catherine SAC-EPEE. Rééquilibrage énergétique, gestion du stress, bien-être physique et émotionnel. Prestations en cabinet et en entreprise (QVCT).",
    keywords:
      "shiatsu La Ciotat, praticienne shiatsu, bien-être, rééquilibrage énergétique, QVCT, Provence",
    image: siteData.images.hero,
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: "Catherine' Shiatsu",
      description:
        "Cabinet de Shiatsu à La Ciotat — Catherine SAC-EPEE, praticienne en Shiatsu.",
      image: siteData.images.portrait,
      telephone: siteData.contact.phone,
      email: siteData.contact.email,
      address: {
        "@type": "PostalAddress",
        addressLocality: "La Ciotat",
        addressCountry: "FR",
      },
      areaServed: ["La Ciotat", "Aubagne", "Aix-en-Provence", "Marseille"],
    },
  });

  return (
    <div className="site">
      <Header />
      <main>
        <Hero />
        <QuoteSection
          text={siteData.quotes.rohn.text}
          author={siteData.quotes.rohn.author}
          variant="red"
          background="beige"
        />
        <LeShiatsu />
        <QuoteSection
          text={siteData.quotes.bouheret.text}
          author={siteData.quotes.bouheret.author}
          variant="red"
          background="beige-deco"
        />
        <PourQui />
        <Seance />
        <QuoteSection
          text={siteData.quotes.chengManChing.text}
          author={siteData.quotes.chengManChing.author}
          variant="blue"
          background="beige"
        />
        <Praticienne />
        <QVCT />
        <Contact />
        <Tarifs />
        <CartesCadeaux />
        <BlogPreview />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
